module.exports = __webpack_public_path__ + "static/media/romanian_flag.a8c52caa.svg";